import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import {isCompletedHotelInfoHistory} from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Table from '../../../molecules/Table/Table'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './HotelContent.scss'
import HotelContentService from 'services/HotelContentService'

class HotelContent extends Component {
    constructor(props) {
        super(props)
        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)
        if (!hotelCode || !hotelInfo) {
            this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
        }
        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            error: undefined,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            initialValues: { ...this.initialValues },
            hotelInfoCompletedHistory: hotelInfoCompletedHistory,
            hotelContentStatus: {
                'Wedding': 'Pending'
            },
            proceedButtonName: 'Start Editing'
        }
    }

    initialValues = {
        
    }

    //Table Headers
    headers = ['Content Type', 'Status', 'Action']
    
    hotelContentRoutes = {
        'Wedding': RouteConst.ROUTE_HOTEL_CONTENT_WEDDING_PAGE
    }

    /**
     * Lifecycle method that runs after the component mounts.
     * Gets data from the session if state is COMPLETED, otherwise from the service, and sets initial values for the form.
     */
    async componentDidMount() {
        let hotelContentStatus = {
            'Wedding': 'Pending'
        }
        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {   
            await HotelContentService.getHotelContents({ hotelCode: this.state.hotelCode })
                .then(response => {
                    if (!response?.error) {
                        response.forEach(hotelContent => {
                            if (hotelContent.typeCode == 'WEDDING')
                                hotelContentStatus['Wedding'] = 'Complete';
                        })
                        this.setState({ error: undefined, isLoading: false, hotelContentStatus: hotelContentStatus })
                    } else {
                        this.setState({ isLoading: false })
                    }
                }).catch(error => {
                    this.setState({
                        isLoading: false,
                        showErrorModal: true,
                        errorMessage: 'There was an error while reading Hotel Content data'
                    })
                });
            this.setState({ isLoading: false })
        } else {
            await HotelContentService.getHotelContents({ hotelCode: this.state.hotelCode })
                .then(response => {
                    if (!response?.error) {
                        response.forEach(hotelContent => {
                            if (hotelContent.typeCode == 'WEDDING')
                                hotelContentStatus['Wedding'] = 'Complete';
                        })
                        this.setState({ error: undefined, isLoading: false, hotelContentStatus: hotelContentStatus })
                    } else {
                        this.setState({ isLoading: false })
                    }
                }).catch(error => {
                    this.setState({
                        isLoading: false,
                        showErrorModal: true,
                        errorMessage: 'There was an error while reading Hotel Content data'
                    })
                });
            this.setState({ isLoading: false }) 
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    error: this.props.errorMessage,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription,
                    showUpdateModal: false,
                    isLoading: false,
                    hotelContentStatus: {
                        'Wedding': 'Pending'
                    }
                })
            } else {
                if (this.state.actionPerformed === FormConst.ACTION_SAVE_AND_PROCEED) {
                    this.props.history.push(RouteConst.ROUTE_HOTEL_CONTENT_PAGE)
                } else {
                    this.setState({
                        isLoading: false,
                        showUpdateModal: false,
                        errorMessage: undefined,
                        alertEditIndex: -1,
                        hotelContentStatus: {
                            'Wedding': 'Pending'
                        }
                    })
                }
            }
        }
    }

    async onClickActionButton(route) {
        let data = {typeCode: "skip"};
        await HotelContentService.putHotelContent({hotelCode: this.state.hotelCode, formData: data});
        this.props.history.push(route);
    }

    render() {
        let tableData = []
        const hotelBrandCode = this.state.hotelInfo.brandCode;
        let availableHotelContent = FormConst.HOTEL_CONTENT_DEFAULT_SECTIONS[hotelBrandCode];
        let isComplete =  false;
        let editRoute = RouteConst.ROUTE_POLICIES_PAGE;
        let statusTracker = 0;
        for (const type in this.state.hotelContentStatus) {
            const status = this.state.hotelContentStatus[type]
            if (availableHotelContent === undefined || !availableHotelContent.includes(type.charAt(0))) {
                continue;
            }
            if (this.state.hotelContentStatus.hasOwnProperty(type)) {
                tableData.push([type, status, <NavLink to={this.hotelContentRoutes[type]}>{status === 'Complete' ? 'Edit' : 'Add'}</NavLink>])
                if (status == 'Complete') {
                    statusTracker++;
                }
            }
        }
        if (statusTracker >= 1 || this.state.IsSectionComplete) {
            isComplete = true;
        }
        return (
            <div className='hotel-policies-page'>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><NavLink to='/'>Home</NavLink></li>
                        <li className="breadcrumb-item active" aria-current="page">Hotel Content</li>
                    </ol>
                </nav>
                <p>Based upon your brand, you may have additional on-site amenities, such as wedding space. By adding additional details around the select on-site amenities below, you can attract guests seeking an unforgettable stay.</p>
                <p>This section is optional.  If you do not want to include enhanced information for this section, click Save & Proceed.</p>
                {
                    !this.state.isLoading
                    && (
                        <Table bordered striped headers={this.headers} data={tableData} className='hotel-content-table' />
                    )
                }
                {
                    isComplete
                    && (
                        <div className="alert alert-success" role="alert">
                            <h4 className="alert-heading">Well done!</h4>
                            <p>You successfully finished this module. Let's proceed to the <NavLink to={SideNavEntryMapping.HOTEL_CHARGES.current.route} className='alert-link'>next</NavLink> module</p>
                        </div>
                    )
                }
                <FormFooter
                    form={SideNavEntryMapping.HOTEL_CONTENT}
                    submitName='Save & Proceed'
                    onSubmit={() => this.onClickActionButton(editRoute)}
                    noReset />
                <FormModal
                    id='hotel-policies-page-loading-modal'
                    title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                    hotelInfo={this.state.hotelInfo}
                    body={<h6>{this.state.loadingMessage}</h6>}
                    show={this.state.isLoading}
                    isLoadingIndicator />
                <FormModal
                    id='hotel-policies-page-error-modal'
                    title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                    hotelInfo={this.state.hotelInfo}
                    body={<h6>{this.state.errorMessage}</h6>}
                    isError
                    show={this.state.showErrorModal} />
            </div>
        )
    }
}
export default withFormLayout(HotelContent, SideNavEntryMapping.HOTEL_CONTENT)